<template>
  <div class="news-page" v-if="selectedArticle">
    <div class="w3-row">
        <div class="w3-col s12 m6 l8">
          <div class="sectionHeader">
            <h5 class="truncate" style="padding:0 8px 0 12px">{{selectedArticle.title}}</h5>
          </div>
          <template v-if="width > 600">
            <div class="newsContent whiteContainer" v-html="selectedArticle.content"></div>
          </template>
        </div>
        <div class="w3-col s12 m6 l4">
          <img v-if="selectedArticle.image != ''" :alt="selectedArticle.title" class="newsImage" style="padding:0 4px; margin-bottom:8px;" :src="selectedArticle.image" />
          <template v-if="width < 601">
            <div class="newsContent whiteContainer" v-html="selectedArticle.content"></div>
            <div class="sectionHeader w3-display-container">
              <!-- <button type="button" class="w3-button w3-display-left btnBack" @click="previousNews()">Previous</button> -->
              <h5>News Details</h5>
              <!-- <button type="button" class="w3-button w3-display-right btnNext" @click="nextNews()">Next</button> -->
            </div>
            <div class="card-body whiteContainer w3-padding" style="margin:0 4px 8px;">
              <ul class="list-group" style="list-style-type:none;">
                <template v-if="!showCustomAd">
                  <a :href="'https://maps.google.com/?q=' + selectedArticle.address" target="_blank" rel="noreferrer" class="newsInfoLink" v-if="selectedArticle.address">
                    <li class="list-group-item list-group-item-action"><font-awesome-icon icon="map" class="listItem"></font-awesome-icon>{{selectedArticle.address | titlecase()}}</li>
                  </a>
                </template>
                <template v-if="showCustomAd">
                  <a v-if="selectedArticle.address">
                    <li class="list-group-item list-group-item-action"><font-awesome-icon icon="map" class="listItem"></font-awesome-icon>{{selectedArticle.address | titlecase()}}</li>
                  </a>
                </template>
                <li v-for="(date, index) of selectedArticle.dates" :key="index" class="list-group-item list-group-item-action">
                  <font-awesome-icon icon="calendar" class="listItem"></font-awesome-icon>
                  {{date.formattedDate | date('day')}} {{date.formattedDate | date('year')}} • {{date.formattedStart | date('time')}} - {{date.formattedEnd | date('time')}}
                </li>
              </ul>
            </div>
          </template>

          <template v-if="selectedArticle.url">
            <div class="sectionHeader w3-display-container">
              <h5>Share Page</h5>
            </div>
            <div class="whiteContainer" style="margin:0 4px 8px;">
              <template v-if="!showCustomAd">
                <div class="w3-row">
                  <div class="w3-col s4 w3-center">
                    <a class="w3-block w3-blue w3-padding" :href="share('fb', selectedArticle.url)" target="_blank" aria-label="facebook share" rel="noreferrer">
                      <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
                    </a>
                  </div>
                  <div class="w3-col s4 w3-center">
                    <a class="w3-block w3-light-blue w3-padding" :href="share('tw', selectedArticle.url)" target="_blank" aria-label="twitter share" rel="noreferrer">
                      <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                    </a>
                  </div>
                  <div class="w3-col s4 w3-center">
                    <a class="w3-block w3-red w3-padding" :href="share('gp', selectedArticle.url)" target="_blank" aria-label="google share" rel="noreferrer">
                      <font-awesome-icon :icon="['fab', 'google-plus']"></font-awesome-icon>
                    </a>
                  </div>
                </div>
              </template>
              <template v-if="showCustomAd">
                <div class="w3-row">
                  <div class="w3-col s4 w3-center">
                    <a class="w3-block w3-blue w3-padding">
                      <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
                    </a>
                  </div>
                  <div class="w3-col s4 w3-center">
                    <a class="w3-block w3-light-blue w3-padding">
                      <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                    </a>
                  </div>
                  <div class="w3-col s4 w3-center">
                    <a class="w3-block w3-red w3-padding">
                      <font-awesome-icon :icon="['fab', 'google-plus']"></font-awesome-icon>
                    </a>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <div class="card" style="margin-bottom:8px;" v-if="width > 600">
            <div class="sectionHeader w3-display-container">
              <h5>News Details</h5>
            </div>
            <div class="card-body whiteContainer w3-padding" style="margin:0 4px;">
              <ul class="list-group" style="list-style-type:none;">
                <li class="list-group-item infoIconGrid">
                  <div>
                    <font-awesome-icon icon="user" class="listItem infoIcon"></font-awesome-icon>
                  </div>
                  <span>{{selectedArticle.author}}</span>
                </li>
                <li class="list-group-item infoIconGrid">
                  <div>
                    <font-awesome-icon icon="calendar" class="listItem infoIcon"></font-awesome-icon>
                  </div>
                  <span>{{$options.filters.date(selectedArticle.date * 1000, 'mediumDate')}}</span>
                </li>
              </ul>
            </div>
          </div>

        </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'newsDetail',
  metaInfo () {
    let selectedArticle = this.selectedArticle
    if (selectedArticle) {
      return {
        title: `${selectedArticle.title} - Daytona Local`,
        meta: [
          {name: 'title', content: selectedArticle.title},
          {name: 'description', content: selectedArticle.title + ' Details and Information Page on DaytonaLocal.com'},
          {property: 'og:title', content: selectedArticle.title + ' - Daytona Local'},
          {property: 'og:site_name', content: 'Daytona Local'},
          {property: 'og:type', content: 'website'},
          {property: 'og:url', content: 'https://daytonalocal.com/news-details/' + selectedArticle.url},
          {property: 'og:image', content: selectedArticle.image},
          {property: 'og:description', content: selectedArticle.leading},
  
          // Twitter card
          {name: 'twitter:card', content: selectedArticle.leading},
          {name: 'twitter:site', content: 'https://daytonalocal.com/news-details/' + selectedArticle.url},
          {name: 'twitter:title', content: selectedArticle.title + ' - Daytona Local'},
          {name: 'twitter:description', content: selectedArticle.leading},
          {name: 'twitter:image:src', content: selectedArticle.image},
  
          // Google / Schema.org markup:
          {itemprop: 'name', content: selectedArticle.title + ' - Daytona Local'},
          {itemprop: 'description', content: selectedArticle.leading},
          {itemprop: 'image', content: selectedArticle.image}
        ]
      }
    }
  },
  props: ['showCustomAd'],
  data() {
    return {
      width: window.innerWidth
    }
  },
  computed: mapState([
    'news',
    'selectedArticle',
    'selectedAd'
  ]),
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
    goBack() {
      this.$router.back()
      window.scrollTo(0, 0)
    },
    share(type, url) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/news-details/" + url)
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/news-details/" + url)
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/news-details/" + url)
      } else {
        // nothing
      }
      return sharePage
    }
  },
  created() {
    if (this.$route.params.url) {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getNews').then(() => {
        this.$store.commit('setLoading', false)
        for (let news of this.news) {
          if (news.url === this.$route.params.url) {
            this.$store.commit('setSelectedArticle', news)
            return
          }
        }
        
      })
    }
  }
}
</script>

<style scoped>
  .newsContent {padding:15px; color:#333;}

  .list-group {margin-bottom:15px; margin-top:15px;}
  .list-group-item {font-weight:300; cursor:pointer;}
  .list-group-item img {max-width:150px; float:left; margin:5px 10px 5px 0;}
  .listIcon {width:30px; color:#263238;}

  .newsImage {width:100%; margin-bottom:15px;}

  .sectionHeader {text-align:center;}

  .btnBack {background:#263238; color:#fafafa;}
  .btnBack:hover {background:#33434b;}
  .btnNext {background:#263238; color:#fafafa;}
  .btnNext:hover {background:#33434b;}

  .card-body ul {margin:0; padding:0;}
  a.newsInfoLink {text-decoration:none; color:inherit;}
  a.newsInfoLink:hover {text-decoration:underline; color:inherit;}

  .infoIconGrid {display:grid; grid-template-columns: 20px 1fr; grid-gap:8px; line-height:30px;}
  .infoIconGrid div {display:inline-flex; align-items: center;}
  .infoIconGrid span {font-weight:400;}
  .infoIcon {color:#172A3A; vertical-align: middle;}
</style>
